const SELECTORS = window.SELECTORS || {
  container: '[data-register-container]',
  countryWrapper: '[data-countries-wrapper]',
  firstnameInput: '#FirstName',
  lastnameInput: '#LastName',
  emailInput: '#Email',
  passwordInput: '#CreatePassword',
  passwordLengthError: '[data-password-error]',
  birthDayInput: '#birth_day',
  birthMonthInput: '#birth_month',
  form: 'form',
  submitButton: '[data-button]',
  noLabelsFix: '[data-nolabel-fix]',
  birthdayHiddenInput: '[data-birthday]',
  phoneInput: '#Phone',
  countryValue: '#AddressCountry'
};

const FORM_KEYS = {
  email: 'customer[email]',
  firstName: 'customer[first_name]',
  lastName: 'customer[last_name]',
  password: 'customer[password]',
  countryCode: 'country_code',
  birthDay: 'birth_day',
  birthMonth: 'birth_month',
  phone: 'customer[phone]',
};

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector(SELECTORS.container);
  addFormSubmission(container);
})
const INVALID_DATES = ['30-02', '31-02', '31-04', '31-06', '31-09', '31-11'];
/**
 * @function addFormSubmission - validate and send to Klaviyo before proceeding to
 * shopify form submission.
 *
 * @param {Element} container - base element all further selector queries
 */
function addFormSubmission(container) {
  const form = container.querySelector(SELECTORS.form);
  const button = container.querySelector(SELECTORS.submitButton);
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    form.removeAttribute("onsubmit");

    const [passwordInput, passwordLengthError, dayInput, monthInput, phoneInput, countryInput, ...requiredInputs] = [
      SELECTORS.passwordInput,
      SELECTORS.passwordLengthError,
      SELECTORS.birthDayInput,
      SELECTORS.birthMonthInput,
      SELECTORS.phoneInput,
      SELECTORS.countryValue,
      SELECTORS.firstnameInput,
      SELECTORS.lastnameInput,
      SELECTORS.emailInput,
    ].map((selector) => container.querySelector(selector));

    showOrHideValidations(requiredInputs, passwordInput, passwordLengthError, dayInput, monthInput, phoneInput, countryInput);

    if (formIsValid(requiredInputs, passwordInput, dayInput, monthInput, phoneInput, countryInput)) {
      console.log("isValid")
      button.setAttribute('disabled', true);
      button.innerText = 'Joining the Beach Club...';
      var customerValid;
      try {
        customerValid = await checkProfileCompletion(container.dataset.klaviyoCustomerListId, form);
      } catch(e) {
        console.log("error" , e)
      }
      if (!customerValid) {
        form.querySelector('[name="return_to"]').value = '/account/login';
      } else {
        try {
          await sendToKlaviyo(container.dataset.klaviyoCustomerListId, form);
        } catch(e) {
          console.log("error" , e)
        }
      }
      form.submit();
    }
  });

  form.addEventListener('change', (event)=> {
    const requiredInputs = [
      SELECTORS.firstnameInput,
      SELECTORS.lastnameInput,
      SELECTORS.emailInput,
      SELECTORS.passwordInput,
    ].map((selector) => container.querySelector(selector));

    if (allMandatoryFields(requiredInputs)) {
      form.querySelector(SELECTORS.submitButton).removeAttribute("disabled")
    } else {
      form.querySelector(SELECTORS.submitButton).setAttribute("disabled", true)
    }
  })
}

/**
 * @function showOrHideValidations - shows/hides validations to the user
 *
 * @param {Element[]} requiredInputs - array of all inputs that must have a value
 * @param {Element}   passwordInput
 * @param {Element}   passwordLengthError
 * @param {Element}   dayInput
 * @param {Element}   monthInput
 */
function showOrHideValidations(requiredInputs, passwordInput, passwordLengthError, dayInput, monthInput, phoneInput, countryInput) {
  // Make sure password exists and is long enough
  if (!passwordInput.value) {
    passwordInput.classList.add('input-error');
    passwordInput.nextElementSibling.classList.remove('hide');
    passwordLengthError.classList.add('hide');
  } else if (passwordInput.value.length < 5) {
    passwordInput.classList.add('input-error');
    passwordInput.nextElementSibling.classList.add('hide');
    passwordLengthError.classList.remove('hide');
  } else {
    passwordInput.classList.remove('input-error');
    passwordInput.nextElementSibling.classList.add('hide');
    passwordLengthError.classList.add('hide');
  }

  // tedium
  if (dayInput.value && !monthInput.value) {
    dayInput.classList.remove('input-error');
    monthInput.classList.add('input-error');
    dayInput.parentElement.nextElementSibling.classList.remove('hide');
  } else if ((!dayInput.value && monthInput.value) || INVALID_DATES.includes(`${dayInput.value}-${monthInput.value}`)) {
    dayInput.classList.add('input-error');
    monthInput.classList.remove('input-error');
    dayInput.parentElement.nextElementSibling.classList.remove('hide');
  } else {
    dayInput.classList.remove('input-error');
    monthInput.classList.remove('input-error');
    dayInput.parentElement.nextElementSibling.classList.add('hide');
  }

  requiredInputs.forEach((input) => {
    if (input.value) {
      input.classList.remove('input-error');
      input.nextElementSibling.classList.add('hide');
    } else {
      input.classList.add('input-error');
      input.nextElementSibling.classList.remove('hide');
    }
  });

  if(phoneInput.value.length > 0) {
    if(validatePhone(phoneInput.value, countryInput)) {
      phoneInput.classList.remove('input-error');
      phoneInput.closest('.phone-input-container').nextElementSibling.classList.add('hide');
    } else {
      phoneInput.classList.add('input-error');
      phoneInput.closest('.phone-input-container').nextElementSibling.classList.remove('hide');
    }
  }
}

/**
 * @function formIsValid - whether the form as a whole is ready for submission.
 *
 * @param {Element[]} requiredInputs - array of all inputs that must have a value
 * @param {Element}   passwordInput
 * @param {Element}   dayInput
 * @param {Element}   monthInput
 *
 * @returns {boolean}
 */
const formIsValid = (requiredInputs, passwordInput, dayInput, monthInput, phoneInput, countryInput) =>
  requiredInputs.every(({value}) => Boolean(value)) &&
  passwordInput.value &&
  passwordInput.value.length >= 5 &&
  ((dayInput.value && monthInput.value) || (!dayInput.value && !monthInput.value)) &&
  !INVALID_DATES.includes(`${dayInput.value}-${monthInput.value}`) &&
  (validatePhone(phoneInput.value, countryInput) || phoneInput.value.length === 0);

const allMandatoryFields = (requiredInputs) =>
  requiredInputs.every(({value}) => Boolean(value));

async function checkProfileCompletion(listId, form) {
  const formData = new FormData(form);
  let response;
  if (!listId) {
    console.log('no list ID')
    reportKlaviyoSubmissionFailure(form, formData);
    return false
  }

  try {
    const response = await fetch(window.datajetUrl, {
      method: 'POST',
      body: formData
    });
    const data = await response.json();
    console.log(data);
    return data.status === 'ok' ? true : false;
  } catch(err) {
    console.log("error" , error);
    return false;
  }
}

/**
 * @function sendToKlaviyo - Before submitting the registration to Shopify we
 * attempt to add the customer to the Klaviyo with custom attributes not stored
 * by shopify.
 *
 * @param {string}  listId     - which subscriber list are we sending this too?
 * @param {Element} form       - form element
 * @param {number}  retryCount - defaults to 0. We'll try up to three times to send this to Klaviyo.
 *
 * @reurns {void}
 */
async function sendToKlaviyo(listId, form, retryCount = 1) {
  const formData = Object.fromEntries(new FormData(form));
  let response;

  if (!listId) {
    console.log('no list ID')
    reportKlaviyoSubmissionFailure(form, formData);
    return;
  }

  try {
    response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'cache-control': 'no-cache',
      },
      body: new URLSearchParams(
        Object.entries({
          g: listId,
          email: formData[FORM_KEYS.email],
          phone_number: formatPhoneNumber(formData[FORM_KEYS.phone], formData[FORM_KEYS.countryCode]),
          // pass in additional fields
          $fields: '$source, $first_name, $last_name, $birthday, $countryCode, $phone',
          $source: 'Account Creation',
          $first_name: formData[FORM_KEYS.firstName],
          $last_name: formData[FORM_KEYS.lastName],
          $birthday: formatBirthday(formData),
          $countryCode: formData[FORM_KEYS.countryCode],
        })
      ).toString(),
    });
  } catch (error) {
    console.log("error" , error)
    window.console.error(error);
  }

  if (!response || !response.ok) {
    if (retryCount < 3) {
      await sendToKlaviyo(listId, form, retryCount + 1);
    } else {
      reportKlaviyoSubmissionFailure(form, formData);
    }
  }

  if(formData[FORM_KEYS.phone].length > 0) {
    const note = document.createElement('input');
    note.setAttribute('name', 'customer[note][phone]');
    note.style.display = 'none';
    note.setAttribute(
      'value',
      `${formatPhoneNumber(formData[FORM_KEYS.phone], formData[FORM_KEYS.countryCode])}`
    );
    form.appendChild(note);
  }

  console.log(formData)
}


/**
 * @function reportKlaviyoSubmissionFailure - adds a note to the customer
 * regarding the failure to create a Klaviyo record
 *
 * @param {Element} form
 * @param {FormData} formData
 */
function reportKlaviyoSubmissionFailure(form, formData) {

  const note = document.createElement('input');
  note.setAttribute('name', 'customer[note][signup_error]');
  note.style.display = 'none';
  note.setAttribute(
    'value',
    `This customer was unsuccessfully submitted to Klaviyo with the following additional information: \n ${formatBirthday(formData) && `- $birthday: ${formatBirthday(formData)}` } \n - $countryCode: ${formData[FORM_KEYS.countryCode]}`
  );
  form.appendChild(note);
}

function formatPhoneNumber(input, country) {
  input.replace(/-|\s/g, '');
  if (country === "AU") {
    return '+61' + input;
  } else if(country === "NZ") {
    return '+64' + input;
  } else if(country === "SG") {
    return '+65' + input;
  } else if (country === "US" || country === "US") {
    return '+1' + input;
  } else if (country === "GB") {
    return '+44' + input;
  }
}

function validatePhone(input, country) {
  console.log(country.value)
  let regex
  if (country.value === "AU") {
    regex = /^(?:\d{9}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  } else if(country.value === "NZ" || country.value === "US" || country.value === "CA") {
    regex = /^(?:\d{10}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  } else if(country.value === "SG") {
    regex = /^(?:\d{8}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  } else if (country.value === "GB") {
    regex = /^(?:\d{10}|\d{3}-\d{3}-\d{3}|\d{3} \d{3} \d{3})$/;
  }
  return regex.test(input);
}

function formatBirthday(formData) {
  return `${new Date().getFullYear()}-${formData[FORM_KEYS.birthMonth]}-${formData[FORM_KEYS.birthDay]}`;
}
